import { render, staticRenderFns } from "./giftadd.vue?vue&type=template&id=13960330&scoped=true"
import script from "./giftadd.vue?vue&type=script&lang=js"
export * from "./giftadd.vue?vue&type=script&lang=js"
import style0 from "./giftadd.vue?vue&type=style&index=0&id=13960330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13960330",
  null
  
)

export default component.exports